const Loader = () => {
  return (
    <div className="flex items-center justify-center min-h-96 ">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
    </div>
  );
};
export default Loader;
